// Confirmação de ação destrutiva.
//
// Revogar chave, arquivar camada e despublicar coleção eram um clique só — e a
// última é a mais destrutiva do sistema: a URL que o cliente salvou no projeto
// de ArcGIS dele para de responder.
//
// A confirmação pede para **digitar o nome** quando o efeito alcança alguém de
// fora. Um "tem certeza?" com dois botões é clicado no automático; escrever
// `sigef-sp` exige ler o que está escrito.

import { useState, type ReactNode } from "react";

export function Confirmar({
  titulo,
  descricao,
  confirmacao,
  rotuloAcao,
  perigo,
  motivoObrigatorio,
  aoConfirmar,
  aoCancelar,
  pendente,
}: {
  titulo: string;
  descricao: ReactNode;
  /** Quando presente, exige digitar este texto. Use para efeito externo. */
  confirmacao?: string;
  rotuloAcao: string;
  perigo?: boolean;
  /**
   * Exige o motivo antes de liberar a ação.
   *
   * Usado na rejeição em lote, onde o servidor recusa sem ele: pedir aqui é o que
   * evita a recusa chegar como erro DEPOIS de a pessoa confirmar. Rejeição é a
   * decisão que alguém questiona meses depois, e sem razão registrada o registro
   * não responde nada.
   */
  motivoObrigatorio?: boolean;
  aoConfirmar: (motivo: string) => void;
  aoCancelar: () => void;
  pendente?: boolean;
}): ReactNode {
  const [digitado, setDigitado] = useState("");
  const [motivo, setMotivo] = useState("");
  const liberado =
    (confirmacao === undefined || digitado.trim() === confirmacao) &&
    (!motivoObrigatorio || motivo.trim() !== "");

  return (
    <div className="modal-fundo" role="dialog" aria-modal="true" aria-label={titulo}>
      <div className="modal">
        <h3>{titulo}</h3>
        <div className="modal-corpo">{descricao}</div>

        {confirmacao !== undefined ? (
          <div className="campo">
            <label htmlFor="confirmar">
              Digite <code className="mono">{confirmacao}</code> para confirmar
            </label>
            <input
              id="confirmar"
              value={digitado}
              autoFocus
              onChange={(e) => setDigitado(e.target.value)}
            />
          </div>
        ) : null}

        <div className="campo">
          <label htmlFor="motivo">
            Motivo (vai para a auditoria)
            {motivoObrigatorio ? <span className="campo-obrigatorio"> — obrigatório</span> : null}
          </label>
          <input
            id="motivo"
            value={motivo}
            required={motivoObrigatorio}
            placeholder={
              motivoObrigatorio
                ? "o que explica a rejeição daqui a seis meses"
                : "opcional, e o que explica a decisão daqui a seis meses"
            }
            onChange={(e) => setMotivo(e.target.value)}
          />
        </div>

        <div className="linha-botoes">
          <button
            className={`btn ${perigo ? "btn-perigo" : "btn-primario"}`}
            disabled={!liberado || pendente}
            onClick={() => aoConfirmar(motivo.trim())}
          >
            {pendente ? "…" : rotuloAcao}
          </button>
          <button className="btn" onClick={aoCancelar}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
